import { Component, computed, EventEmitter, inject, Input, Output } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoadingService, LoadingType } from '../../services/loading.service';
import { Dialog } from '@angular/cdk/dialog';
import { PaginaDelenDialogComponent } from '../../dialogs/pagina-delen/pagina-delen-dialog/pagina-delen-dialog.component';
import { Overlay } from '@angular/cdk/overlay';
import { AsyncPipe } from '@angular/common';
import { CssSpinnerComponent } from '../css-spinner/css-spinner.component';
import { TabMenuComponent } from '@cumlaude/shared-components-menu';
import { DatasnapUrlService } from '../../services/datasnap-url.service';
import { RDatasnapResult } from '@cumlaude/service-contract';
import { SidebarService } from '@cumlaude/shared-components-overlays';
import { DatasnapResultSidebarComponent } from '../../sidebars/datasnap/datasnap-result-sidebar.component';
import { dutchDate } from '@cumlaude/shared-utils';
import { ButtonComponent } from '@cumlaude/shared-components-buttons';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-user-tab-menu',
	templateUrl: './user-tab-menu.component.html',
	styleUrls: ['./user-tab-menu.component.scss'],
	imports: [AsyncPipe, CssSpinnerComponent, TabMenuComponent, ButtonComponent, IconComponent],
})
export class UserTabMenuComponent {
	private readonly dialog = inject(Dialog);
	private readonly overlay = inject(Overlay);
	protected readonly datasnapUrlService = inject(DatasnapUrlService);
	private readonly sidebarService = inject(SidebarService);
	private readonly loadingService = inject(LoadingService);

	showExportSpinner = this.loadingService.shouldShowLoadingIndicatorSignal(LoadingType.EXPORT);

	@Input()
	exportVisible = false;

	@Input()
	shareVisible = false;

	@Output()
	exportClicked = new EventEmitter<void>();

	sharePagina() {
		this.dialog.open<void>(PaginaDelenDialogComponent, {
			positionStrategy: this.overlay.position().global().top('7rem').right('4rem'),
		});
	}

	openHistory(datasnapResults: RDatasnapResult[]) {
		this.sidebarService.open(DatasnapResultSidebarComponent, { data: datasnapResults });
	}

	// als we dit als normale functie in de template aanroepen en de REST-call gaat fout
	// blijft hij re-renderen
	readonly snapshotTitle = computed(() => {
		const key = this.datasnapUrlService.currentSnapshotKey();
		if (key === undefined) return of('');

		return this.datasnapUrlService.getResult(key).pipe(
			map((result) => dutchDate(result.tsRequest)),
			catchError(() => of('[kan snapshot niet laden]'))
		);
	});
}
